import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import Container from "@mui/material/Container";
import Stack from "@mui/material/Stack";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";

import { Seo } from "src/components/seo";
import { usePageView } from "src/hooks/use-page-view";
import Software from "./list";
import { useTranslation } from "react-i18next";
import { useTheme } from "@mui/material";

const Page = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  usePageView();

  return (
    <>
      <Seo title="Software" />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          mt: 5,
          py: 2,
          backgroundColor: (theme) =>
            theme.palette.mode === "dark" ? "neutral.800" : "neutral.50",
        }}
      >
        <Container maxWidth="xl">
          {/* <Box textAlign="center">
            <Typography
              variant="h3"
              sx={{
                textAlign: "center",
                fontWeight: "bold",
                mb: 2,
                pt: 10,
                color: theme.palette.primary.main,
              }}
            >
              {t("Apps")}
            </Typography>
          </Box>

          <Typography
            color="text.secondary"
            sx={{ mt: 2, mb: 2, textAlign: "center" }}
            variant="body1"
          >
            {t("Overview of open source diabetes management software")}
          </Typography> */}

          <Divider sx={{ my: 2 }} />

          <Stack spacing={4}>
            <Card>
              <Software />
            </Card>
          </Stack>
        </Container>
      </Box>
    </>
  );
};

export default Page;
